<template>
  <div class="web">
    <div class="pc-box">
      <!--搜索-->
      <div class="pc-search">
        <div class="pc-search-auto">
        <span>
          <img src="../../assets/logo.png">
          <em>师生互选</em>
        </span>
          <van-search
              v-model="queryParams.name"
              show-action
              placeholder="请输入搜索关键词"
              @search="onSearch"
              :clearable="false"
          >
            <template #action>
              <div @click="onSearch">搜索</div>
            </template>
          </van-search>
        </div>
      </div>
      <!--搜索-->
      <div class="box-title">
        <h2 class="clearfiex"><b>师生互选</b><van-button style="margin-left: 5px" size="small" @click="$router.push('/my/information-pc')">资料修改</van-button></h2>
      </div>
      <!-- 列表数据 -->
      <div class="pc-list">
        <van-pull-refresh v-model="data.topLoading" @refresh="refresh()">
        <van-list
                v-model="data.bottomLoading"
                :finished="!data.hasMore"
                @load="onLoad"
        >
          <div class="tech-list" v-for="item in data.records" :key="item.id">
            <div class="tech-top" @click="toDetail(item)">
              <div class="top-r">
                <h2>{{ item.name }}</h2>
                <div class="time"><img src="@/assets/time.png">活动时间：{{moment(item.startTime).format('YYYY/MM/DD') + '-' + moment(item.endTime).format('YYYY/MM/DD')}}</div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      </div>
      <div class="foot">Copyright © www.senergy.sjtu.edu.cn. All Rights Reserved</div>
    </div>
  </div>
</template>

<script>
  import {FILE_DISPLAY_PREFIX} from '@/api/upload'
  import {queryList} from '@/api/activity/activity'
  import {handlePageData} from '@/utils/common'
  import {getUserInfo} from "@/api/my/my";
  import moment from 'moment'
  export default {
    name: 'Activity',
    components: {},
    data() {
      return {
        moment,
        userInfo: {},
        fileDisplayPrefix: FILE_DISPLAY_PREFIX,
        queryParams: {},
        data: {
          records: [],
          current: 1,
          size: 10,
          total: 0,
          hasMore: true,
          loading: false,
          topLoading: false,
          bottomLoading: false
        },
      }
    },
    computed: {},
    created() {
      getUserInfo().then(res => {
        if (res.code === 10000) {
          this.userInfo = res.result
        }
      })
      this.refresh()
    },
    mounted() {
    },
    methods: {
      // 加载数据
      onLoad() {
        if (this.data.current > 1 && this.data.hasMore) {
          this.getDataList()
        }
      },
      // 刷新列表
      refresh() {
        this.reset();
        this.getDataList();
      },
      reset() {
        this.data.current = 1;
        this.data.total = 0;
        this.data.hasMore = true
      },
      // 获取列表数据
      getDataList() {
        if (this.data.loading) return;
        this.data.loading = true;
        this.queryParams.current = this.data.current;
        this.queryParams.size = this.data.size;
        queryList(this.queryParams).then(res => {
          if (res.code === 10000) {
            setTimeout(() => {
              handlePageData(this.data, res.result)
            }, 100)
          }
        }).finally(() => {
          setTimeout(() => {
            this.data.loading = false;
            this.data.topLoading = false;
            this.data.bottomLoading = false
          }, 100)
        })
      },
      // tab切换回调方法
      tabChange() {
        this.$nextTick(() => {
          this.data.records = [];
          this.refresh()
        })
      },
      onSearch() {
        this.refresh()
      },
      toDetail(item) {
        if (['student', 'freshman'].includes(this.userInfo.mclassCode)) {
          this.$router.push({path: `/activity/teacherList-pc?id=${item.id}`})
        } else {
          this.$router.push({path: `/activity/studentList-pc?id=${item.id}`})
        }
      }
    }
  }
</script>

<style scoped>
.box-title{
  display: flex;
  align-items: center;
  width: 1136px;
  margin:26px auto;
}
.box-title h2{
  display: flex;
  align-items: center;
}
.box-title h2::before{
  display: flex;
  width: 6px;
  height: 21px;
  background: #883032;
  border-radius: 3px;
  margin-right: 5px;
}
.box-title h2 b{
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 22px;
  color: #883032;
}
.web{
  background: #ffffff;
  min-height: 100vh;
}

.pc-search{
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  width: 100%;
  height: 76px;
  border-bottom: 1px solid #dedede;
}
.pc-search h2{
  display: flex;
  padding: 0 20px;
  font-size:18px;
  font-weight: 600;
}
.pc-search-auto{
  width: 1134px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pc-search-auto span{
  display: flex;
  align-items: center;
}
.pc-search-auto span img{
  width: 160px;
  height: 39px;
}
.pc-search-auto span em{
  display: flex;
  height: 26px;
  align-items: center;
  border-left: 1px solid #dedede;
  margin-left: 10px;
  padding-left: 10px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.pc-search-auto h2 a{
  padding: 0 10px 0 0;
  font-size:18px;
  font-weight: 600;
}
.pc-box{
  margin: 0 auto;
}
.pc-list{
  width: 1136px;
  margin: 0 auto;
  min-height: calc(100vh - 136px);
}
.c-class{
  margin: 0 10px;
  border-bottom: 1px solid #dedede;
}
.tech-l{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
}
.tech-list{
  margin: 0;
  border-radius: 0;
  padding: 0 15px;
  margin-bottom:1px;
  display: flex;
}
.tech-top{
  border-bottom: 1px dashed  transparent;
  display: flex;
}
/deep/.van-tabs--line .van-tabs__wrap{
  height: 60px;
}
.time{
  display: flex;
  align-items: center;
  margin-top: 15px;
  font-size: 14px;
  color: #999999;
}
.time img{
  width:13px;
  height: 13px;
  margin-right: 5px;
}
.tech-l em{
  position: relative;
  font-weight: bolder;
  font-size: 14px;
}
.tech-l h2{
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  display: flex;
  align-items: center;
}
.pctime .time3{
  display: none;
}
/deep/ .van-search__content{
  width: 271px;
  height: 27px;
  background: #F7F3EE;
  border-radius: 14px;
}
/deep/ .van-search__action{
  height: 27px;
  border-radius: 100px;
}
/deep/.van-field__control{
  height: 27px;
  line-height: 27px;
}
/deep/.van-tabs__nav--line{
}
/deep/.van-tab{
  flex: inherit;
}
/deep/ .van-tab span{
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 18px;
  color: #666666;
  margin-right: 30px;
}
/deep/ .van-tab--active span{
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 18px;
  color: #883032;
}
/deep/.van-tabs__line{
  left: -25px;
  width: 100px;
  height: 3px;
  background: #883032;
}
/deep/.van-list{
  display: flex;
  flex-wrap: wrap;
  padding-top: 20px;
}
.tech-list{
  width: 360px;
  height: 131px;
  background: #FCFDFD;
  border-radius: 3px;
  border: 1px solid #DEDEDE;
  margin-bottom: 16px;
  margin-right:18px;
  display: flex;
  flex-direction: column;
}
.tech-list:nth-child(3n){
  margin-right: 0;
}
.top-r{
  display: flex;
  flex-direction: column;
  width: 100%;
}
.top-r h2{
  display: flex;
  padding-top:20px;
  width: 311px;
  height: 64px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  line-height: 26px;
  margin-bottom: 15px;
}
.top-r h2 em{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 18px;
  background: #CD0005;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
  margin-left:5px;
}
.info-other{
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.info-other span{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 0 0 50%;
  margin-bottom: 10px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}
.info-item2{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}
.tech-bottom a.qxxz{
  background: #2C68E4;
  color: #ffffff;
}
/deep/.van-button{
  text-align: center;
  justify-content: center;
  width: 75px;
  height: 27px;
  background: #FFFFFF;
  border-radius: 3px;
  border: 1px solid #DEDEDE;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
}
.foot{
  height: 60px;
  background: #A0060E;
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
}
</style>
